{
    "details": {
        "step": "Unternehmensdaten",
        "title": "Unternehmensdaten",
        "name": "Name der Gesellschaft",
        "registration_number": "Handelsregisternummer",
        "registration_country": "Sitz der Gesellschaft (Ländercode, zwei Buchstaben, z.B. DE)",
        "email": "Email-Adresse der Gesellschaft"
    },
    "primary_contact": {
        "primary_contact": "Kontaktperson",
        "first_name": "Vorname",
        "last_name": "Nachname",
        "position": "Position",
        "email": "Emailadresse der Kontaktperson",
        "phone": "Mobiltelefonnummer der Kontaktperson"
    },
    "address": {
        "address": "Adresse",
        "address_line": "Straßenname und -nummer",
        "city": "Stadt",
        "country": "Ländercode (zwei Buchstaben, z.B. DE)",
        "country_short": "Land",
        "zip": "PLZ"
    },
    "pin": {
        "title": "Finway PIN einrichten",
        "step": "Finway PIN einrichten",
        "create_prompt": "Bitte wählen Sie einen finway PIN",
        "create_success": "Finway PIN erfolgreich erstellt",
        "corporate": "Unternehmen",
        "auth": "Finway PIN Authentifizierung",
        "enter_prompt": "Bitte geben Sie Ihre Finway PIN ein, um fortzufahren. Dies ist die PIN, die Sie beim Erstellen Ihres finway Karten-Kontos erstellt haben. Wenn Sie diese vergessen haben, können Sie sie in Ihren Profileinstellungen zurücksetzen."
    },
    "verification": {
        "email": {
            "step": "Email Adresse verifizieren",
            "title": "Email Verifizierung",
            "prompt": "Es wurde ein Verifizierungscode an Ihre Email-Adresse gesendet. Bitte geben Sie ihn unten ein und klicken Sie auf \"Weiter\", um fortzufahren.",
            "success": "Email erfolgreich verifiziert"
        },
        "mobile": {
            "step": "Mobiltelefonnummer verifizieren",
            "title": "Mobiltelefonnummer Verifizierung",
            "prompt": "Es wurde ein Verifizierungscode an Ihre Mobiltelefonnummer gesendet. Bitte geben Sie ihn unten ein und klicken Sie auf \"Weiter\", um fortzufahren.",
            "success": "Mobiltelefonnummer erfolgreich verifiziert."
        },
        "code": "Verifizierungscode",
        "resend_code": "Verifizierungscode erneut senden",
        "code_sent": "Verifizierungscode wurde gesendet"
    },
    "kyb": {
        "step": "KYB Formular",
        "title": "Überprüfung der KYB-Form",
        "rejection_reason": {
            "ROOT_USER_MUST_BE_DIRECTOR_REPRESENTATIVE": "Die antragstellende Person muss entweder ein Geschäftsführer oder ein rechtlicher Vertreter der Gesellschaft sein. Lassen Sie das Formular bitte von einem Geschäftsführer oder einem rechtlichen Vertreter der Gesellschaft ausfüllen.",
            "DOCUMENTS_UNSATISFACTORY": "Die hochgeladenen Dokumente wurden abgelehnt, weil sie die Anforderungen nicht erfüllen. Bitte überprüfen Sie die von Ihnen hochgeladenen Dokumente oder kontaktieren Sie unseren Support unter support@finway.de. Wir helfen Ihnen gerne weiter.",
            "SUPPLIED_DATA_AND_DOCUMENTS_MISMATCH": "Die ausgefüllten Angabenfelder unterscheiden sich von den Daten in den hochgeladenen Dokumenten. Bitte prüfen und korrigieren Sie Ihre Angaben und die hochgeladenen Dokumente.",
            "LANGUAGE_IN_DOCUMENTS_UNSUPPORTED": "Die Sprache der hochgeladenen Dokumente wird nicht unterstützt. Bitte laden Sie die Dokumente in deutscher oder englischer Sprache hoch oder kontaktieren Sie unseren Support unter support@finway.de. Wir helfen Ihnen gerne weiter.",
            "SELFIE_UNSATISFACTORY": "Das hochgeladene Bild der antragstellenden Person wurde abgelehnt. Laden Sie bitte ein anderes Bild hoch.",
            "SELFIE_AND_DOCUMENTS_MISMATCH": "Die hochgeladenen Dokumente stimmen nicht mit dem Bild der antragstellellenden Person überein. Bitte prüfen Sie die hochgeladenen Dokumente und Informationen.",
            "CORPORATE_DETAILS_UNSATISFACTORY": "Die Angaben über die Gesellschaft wurden nicht akzeptiert. Bitte ergänzen Sie die Unternehmensangaben.",
            "BENEFICIARY_DETAILS_UNSATISFACTORY": "Die Angaben über die wirtschaftlich Berechtigten wurden nicht akzeptiert. Bitte ergänzen Sie die Angaben über die Person:en.",
            "REPRESENTATIVE_DETAILS_UNSATISFACTORY": "Die Angaben des Geschäftsführers oder des rechtlichen Vertreters wurden nicht akzeptiert. Bitte ergänzen Sie die Angaben über die Person.",
            "ROOT_USER_UNMATCHED_TO_DIRECTOR_OR_REPRESENTATIVE": "Die antragstellende Person muss entweder ein Geschäftsführer oder ein rechtlicher Vertreter der Gesellschaft sein. Lassen Sie das Formular bitte von einem Geschäftsführer oder einem rechtlichen Vertreter der Gesellschaft ausfüllen.",
            "OTHER": "Der KYB Prozess wurde abgelehnt. Bitte kontaktieren Sie unseren Support unter support@finway.de oder treten Sie mit uns über den Chat unten rechts in Verbindung. Wir helfen Ihnen gerne weiter."
        }
    },
    "business_account": {
        "title": "Erstellung eines Geschäftskontos",
        "step": "Geschäftskonto",
        "success": "Geschäftskonto erfolgreich erstellt.",
        "prompt": "Für den erfolgreichen Abschluss des KYB Prozesses, erstellen Sie bitte ein Geschäftskonto, das für die Aufladung Ihrer Karten verwendet wird, indem Sie auf den Button unten klicken.",
        "enroll_admin_prompt": "Melden Sie alle Administratoren für das Kartenprogramm an (dazu müssen sie eine verifizierte Mobiltelefonnummer haben)."
    },
    "company_position": {
        "director": "Direktor",
        "authorised_representative": "Rechtlicher Vertreter"
    },
    "create_account": "Konto erstellen",
    "industry_type": {
        "title": "Industrie-Typ",
        "accounting": "Buchhaltung",
        "audit": "Audit",
        "finance": "Finanzen",
        "public_sector_administration": "Verwaltung des öffentlichen Sektors",
        "art_entertainment": "Kunst und Unterhaltung",
        "auto_aviation": "Auto und Luftfahrt",
        "banking_lending": "Bankwesen und Kreditwesen",
        "business_consultancy_legal": "Unternehmensberatung und Recht",
        "construction_repair": "Bau und Reparatur",
        "education_professional_services": "Bildung und professionelle Dienstleistungen",
        "informational_technologies": "Informationstechnologien",
        "tobacco_alcohol": "Tabak und Alkohol",
        "gaming_gambling": "Spiele und Glücksspiele",
        "medical_services": "Medizinische Dienstleistungen",
        "manufacturing": "Fabrikations Gewerbe",
        "precious_goods_jewelry": "Edle Waren und Schmuck",
        "non_governmental_organization": "Nichtstaatliche Organisation",
        "insurance_security": "Versicherung und Sicherheit",
        "retail_wholesale": "Einzel- und Großhandel",
        "travel_tourism": "Reisen und Tourismus",
        "freelancer": "Freiberufler",
        "pr_marketing": "Öffentlichkeitsarbeit und Marketing"
    },
    "source_of_funds": {
        "title": "Herkunft der Mittel",
        "labour_contract": "Arbeitsvertrag",
        "civil_contract": "Zivilvertrag",
        "rent": "Miete",
        "funds_from_other_auxiliary_sources": "Mittel aus anderen Hilfsquellen",
        "sale_of_movable_assets": "Verkauf von beweglichem Vermögen",
        "sale_of_real_estate": "Verkauf von Grundstücken",
        "ordinary_business_activity": "Gewöhnliche Geschäftstätigkeit",
        "dividends": "Ausschüttungen",
        "loan_from_financial_institutions_credit_unions": "Darlehen von Finanzinstituten/Kreditgenossenschaften",
        "loan_from_third_parties": "Last von Dritten",
        "sale_of_company_shares_business": "Verkauf von Unternehmensanteilen Geschäft",
        "other": "Sonstiges",
        "specify_other": "Sonstiges angeben"
    },
    "passcode": {
        "update": "Finway PIN aktualisieren",
        "update_success": "Finway PIN Aktualisierung erfolgreich",
        "enter_old_passcode": "Alte finway PIN eingeben",
        "enter_new_passcode": "Neue finway PIN eingeben"
    },
    "passcode_recovery": {
        "title": "Wiederherstellung der Finway PIN",
        "prompt": "Wir haben Ihnen eine Email mit dem Verifizierungscode zum Zurücksetzen Ihrer finway PIN gesendet. Bitte geben Sie ihn in das unten stehende Feld ein.",
        "verification_code": "Verifizierungscode",
        "new_passcode": "Neue finway PIN",
        "enter_new_passcode": "Neue finway PIN eingeben"
    }
}
